<template>
  <div class="fe-time-line">
    <el-form-item
      :label="title"
    >
      <el-steps :direction="direction"  finish-status="success" :active="0">
        <el-step
          v-for="(item, index) in steps"
          :title="item.title"
          :key="index"
          :description="item.description"
          icon="el-icon-success"
        ></el-step>
      </el-steps>
    </el-form-item>
  </div>
</template>
<script>
   export default {
     name: 'fe-time-line',
     props: {
       title: String,
       steps: Array
     },
     data() {
       return {
         direction: 'vertical'
       }
     }
   }

</script>
<style></style>



// WEBPACK FOOTER //
// src/components/FromBase/timeLine.vue